import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';

// Main Pages
import Home from './pages/Home';
import Contact from './pages/Contact';

// Product Pages
import CMSSPage from './pages/CMSSPage';
import ChatbotPage from './pages/ChatbotPage';

// Service Pages
import DigitalTransformationPage from './pages/DigitalTransformationPage';
import CustomDevelopmentPage from './pages/CustomDevelopmentPage';

// Core Pages
import PricingPage from './pages/PricingPage';
import AboutPage from './pages/AboutPage';

// Auth Pages
import SignUpPage from './pages/SignUpPage';
import LoginPage from './pages/LoginPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';

// Legal Pages
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import SecurityPage from './pages/SecurityPage';

// Content Pages
import BlogPage from './pages/BlogPage';
import DocsPage from './pages/DocsPage';
import ChatbotDocsPage from './pages/ChatbotDocsPage';
import CmmsDocsPage from './pages/CmmsDocsPage';
import HelpPage from './pages/HelpPage';
import CaseStudiesPage from './pages/CaseStudiesPage';

// Scroll to top component
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

// 404 Page
const NotFound = () => (
  <div className="pt-20 min-h-screen flex items-center justify-center bg-gray-50">
    <div className="text-center">
      <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
      <p className="text-xl text-gray-600 mb-8">Page not found</p>
      <a href="/" className="btn btn-primary">Go Home</a>
    </div>
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col">
        <Navigation />
        <main className="flex-1">
          <Routes>
            {/* Main Pages */}
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            
            {/* Product Pages */}
            <Route path="/cmms" element={<CMSSPage />} />
            <Route path="/chatbot" element={<ChatbotPage />} />
            
            {/* Service Pages */}
            <Route path="/digital-transformation" element={<DigitalTransformationPage />} />
            <Route path="/custom-development" element={<CustomDevelopmentPage />} />
            
            {/* Core Pages */}
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/about" element={<AboutPage />} />
            
            {/* Auth Pages */}
            <Route path="/signup" element={<SignUpPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/verify-email" element={<VerifyEmailPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            
            {/* Legal Pages */}
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/security" element={<SecurityPage />} />
            
            {/* Content Pages */}
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/docs" element={<DocsPage />} />
            <Route path="/docs/chatbot" element={<ChatbotDocsPage />} />
            <Route path="/docs/cmms" element={<CmmsDocsPage />} />
            <Route path="/help" element={<HelpPage />} />
            <Route path="/case-studies" element={<CaseStudiesPage />} />
            
            {/* 404 */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;